import React from "react";
import { MetricLabel } from "../../MetricCards";
import { ROLE_LABELS } from "../../constants";
import panelStyles from "../../styles/Panel.module.css";
import analyticsStyles from "../../styles/Analytics.module.css";
import { formatNumber, formatPercent } from "../../utils/formatters";

export function AnalyticsRolesBlock({ roles }) {
  return (
    <div className={analyticsStyles.block}>
      <h3>Роли пользователей</h3>
      <div className={panelStyles.tableWrap}>
        <table className={panelStyles.table}>
          <thead>
            <tr>
              <th><MetricLabel title="Роль" hint="Самоопределение при первом входе." /></th>
              <th><MetricLabel title="Новые за 30 дней" hint="Количество и доля новых пользователей с этой ролью." /></th>
              <th><MetricLabel title="Платящие за 30 дней" hint="Количество и доля платящих с этой ролью." /></th>
            </tr>
          </thead>
          <tbody>
            {[0, 1, 2, 3, 4].map((roleId) => (
              <tr key={`role-${roleId}`}>
                <td>{ROLE_LABELS[roleId]}</td>
                <td>{formatNumber(roles.newUsers.roles?.[roleId] || 0)} ({formatPercent(roles.newUsers.shares?.[roleId] || 0)})</td>
                <td>{formatNumber(roles.payers.roles?.[roleId] || 0)} ({formatPercent(roles.payers.shares?.[roleId] || 0)})</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default AnalyticsRolesBlock;
